import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'

import * as s from './styles'
import ButtonNext from 'components/ButtonNext'
import { ReactComponent as BackIcon } from 'assets/icons/ic-backarrow.svg'
import CameraPermissionIcon from 'assets/icons/ic-camera-permission.svg'

import { Context } from 'hooks/BeforeAttendanceContext'

const InformCheckCamera = () => {
  const history = useHistory()
  const { setCurrentStep } = useContext(Context)

  function handleNext() {
    setCurrentStep('CHECK_CAMERA')
  }

  return (
    <s.Page>
      <div>
        <s.Header>
          <BackIcon
            width={30}
            height={30}
            fill="gray"
            onClick={() => history.push('/dashboard')}
          />
        </s.Header>

        <s.Icon src={CameraPermissionIcon} />

        <s.Title type="h3_semibold">O médico vai precisar te ver!</s.Title>
        <s.Message type="p2_regular">
          Vamos precisar que você permita o acesso a sua câmera para que o
          médico possa te ver e realizar a sua avaliação clínica da melhor
          maneira possível!
        </s.Message>
      </div>

      <s.Footer>
        <ButtonNext onClick={handleNext} />
      </s.Footer>
    </s.Page>
  )
}

export default InformCheckCamera
